import React from 'react';
import { connect } from 'react-redux';
import { Formik, Field } from 'formik';
import { Col, Row, Label } from 'reactstrap';
import {
  FormGroup,
  FormSectionTitle,
  Select,
  Separator
} from '../../../components/form/';
import InputField from '../../../components/form/InputField';
import { Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
// import schema from "./schema";

import { signupAdminAction } from '../../../modules/auth/Actions';
import { authIsLoadingSelector } from '../../../modules/auth/Selectors';
import * as Yup from 'yup';
import { checkEmailExistAction } from '../../../modules/users/Actions';
import { emailExistSelector } from '../../../modules/users/Selectors';
import countriesList from './countriesList';
import CitiesList from './CitiesList';
import getLangData from '../../../utils/getLangData';
const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;
const options = [
  { value: '1', label: profileLang.admin },
  { value: '0', label: profileLang.super },
  { value: '7', label: profileLang.partner }
];

const schema = intl => {
  // const getLangData().fields.required = intl.formatMessage({
  //   id: 'AUTH.VALIDATION.getLangData().fields.required',
  // });

  // const INVALID_FIELD = intl.formatMessage({
  //   id: 'AUTH.VALIDATION.INVALID_FIELD',
  // });

  return Yup.object().shape({
    firstName: Yup.string()
      .required(getLangData().fields.required)
      .default(''), //.required(getLangData().fields.required),
    lastName: Yup.string()
      .required(getLangData().fields.required)
      .default(''), //.required(getLangData().fields.required),
    password: Yup.string()
      .required(getLangData().fields.required)
      .min(6)
      .default(''), // .required(getLangData().fields.required),
    email: Yup.string()
      .email()
      .required(getLangData().fields.required)
      .default(''),
    // .required(getLangData().fields.required),
    address: Yup.string().default(''), //.required(getLangData().fields.required),
    city: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    country: Yup.string().default('egypt'), //.required(getLangData().fields.required),
    phone: Yup.string().default(''),
    province: Yup.string().default(''), //.required(getLangData().fields.required),
    zipCode: Yup.string().default(''), //.required(getLangData().fields.required),
    userType: Yup.string()
      .required(getLangData().fields.required)
      .default('')
  });
};

const AdminRegistration = props => {
  // added render={()=>} instead of component in every <Field />
  // added renderEl func that returns <InputField/> with the name

  // const renderEl = (name) => {
  //   return <InputField name={name} />;
  // };

  const { intl, signupAdmin, authIsLoading, emailExists, checkEmail } = props;
  return (
    <Formik
      initialValues={schema().cast()}
      validationSchema={schema()}
      onSubmit={(values, { setStatus, setSubmitting }) => {
        // console.log(values);
        signupAdmin(values, true);
        // console.log({ result });
      }}
    >
      {({ values, handleSubmit, errors, isSubmitting }) => (
        <FormGroup
          handleSubmit={handleSubmit}
          heading={getLangData().buttons.add_admin}
          errors={errors}
          isLoading={authIsLoading}
        >
          {/* {console.log(values)} */}
          <FormSectionTitle>{getLangData().tables.basic_info}</FormSectionTitle>
          <InputField name='firstName' label={fieldsLang.first_name} />
          <InputField name='lastName' label={fieldsLang.last_name} />
          <InputField
            name='email'
            label={fieldsLang.email}
            type='email'
            emailError={emailExists}
            onBlur={() => {
              checkEmail(values.email);
            }}
          />
          <InputField
            name='password'
            label={fieldsLang.password}
            type='Password'
          />
          <Separator />
          {/* <Select
            label="Country"
            name="country"
            options={countriesList}
            // value={countriesList?.filter(
            //   (object) => values?.country?.indexOf(object.value) > -1
            // )}
          /> */}
          <InputField name='address' label={fieldsLang.address} />
          {/* Add Country Select */}
          {/* <InputField name="city" label="City" /> */}
          <Select
            label={fieldsLang.city}
            name='city'
            options={getLangData().cities}
          />
          <InputField name='phone' label={fieldsLang.phone} />
          {/* <InputField name="" label="" />  */}
          <Select
            inArray={true}
            options={options}
            name='userType'
            label={fieldsLang.user_type}
          />{' '}
          {/* <InputField name="province" label={getLangData().f} /> */}
          <InputField name='zipCode' label={fieldsLang.zip_code} />
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  authIsLoading: authIsLoadingSelector(state),
  emailExists: emailExistSelector(state)
});

export default connect(mapStateToProps, {
  signupAdmin: signupAdminAction,
  checkEmail: checkEmailExistAction
})(AdminRegistration);
